<ng-container *ngIf="!isLoading; else loading">
<p-card *ngIf="!verified" class="mt-3">
  <p>
    Your account is not verified. Please verify your email and wait for admin
    approval.
  </p>
</p-card>

<p-card *ngIf="verified" class="mt-3 form-wrapper">
  <div class="p-fluid">
    <div *ngIf="selectedClub" #clubDetails>
      <div class="selected-club-info mb-3" (click)="openClubInfo()">
        <img [src]="selectedClub.img_path" [alt]="selectedClub.name" />
        <h4 class="club-name">{{ selectedClub.name }}</h4>
        <div
          class="location"
          (click)="openMaps(selectedClub.location); $event.stopPropagation()"
        >
          <img src="assets/images/location.png" alt="Location" />
          <span>Address: {{ selectedClub.location }}</span>
        </div>
        <p>Working Hours Today: {{ clubWorkingHoursDisplay }}</p>
        <p>Price from: {{ clubMinPrice }} RSD/h</p>
        <p>{{ selectedClub.number_of_courts }} courts</p>
      </div>

      <div class="p-field mb-3">
        <p-selectButton
          [options]="reservationModeOptions"
          [(ngModel)]="reservationMode"
          (onChange)="onReservationModeChange()"
        ></p-selectButton>
      </div>

      <div class="p-field mb-3">
        <label for="type">Match Type</label>
        <p-dropdown
          id="type"
          [options]="availableMatchTypeOptions"
          optionDisabled="disabled"
          [(ngModel)]="matchType"
          (onChange)="onMatchTypeChange()"
        ></p-dropdown>
      </div>

      <div class="p-field-checkbox mb-3 private-switch">
        <p-inputSwitch
          inputId="private"
          [(ngModel)]="isPrivate"
        ></p-inputSwitch>
        <label for="private" class="ml-2">Private Match</label>
      </div>

      <div class="p-field mb-3" *ngIf="reservationMode === 'basic'">
        <label for="basicName">Player (Full Name)</label>
        <input
          id="basicName"
          type="text"
          pInputText
          placeholder="Enter first and last name"
          [(ngModel)]="basicPlayerFullName"
        />
        <label for="basicPhone" class="mt-2">Phone Number</label>
        <input
          id="basicPhone"
          type="text"
          pInputText
          placeholder="Enter phone number"
          [(ngModel)]="basicPlayerPhone"
          required
        />
        <div class="email-question mt-2">
          <span
            >Do you want to add the player's email to send a confirmation?</span
          >
          <p-inputSwitch
            [(ngModel)]="addEmail"
            (onChange)="onEmailSwitchChange($event)"
          ></p-inputSwitch>
        </div>
        <div *ngIf="basicPlayerEmail" class="mt-2">
          {{ basicPlayerEmail }}
        </div>
      </div>

      <div class="p-field mb-3" *ngIf="reservationMode === 'advanced'">
        <label>Players</label>
        <div *ngIf="matchType === 'single'" class="single-layout">
          <div class="player-field">
            <input
              type="text"
              class="player-input"
              [(ngModel)]="player1Name"
              (input)="searchUsers(player1Name, 1)"
              placeholder="Search by username or full name"
            />
            <ul *ngIf="filteredUsers1.length" class="suggestions-list">
              <li
                *ngFor="let s of filteredUsers1"
                (click)="selectSuggestion(s, 1)"
              >
                {{ s }}
              </li>
            </ul>
            <button
              *ngIf="showAdd1"
              type="button"
              class="add-btn"
              (click)="openAddDialog(1)"
            >
              Add New Player
            </button>
            <div class="booker-radio">
              <input
                type="radio"
                id="booker1"
                name="booker"
                [value]="1"
                [(ngModel)]="bookerIndex"
              />
              <label for="booker1">Booker</label>
            </div>
          </div>
          <span class="vs-text">VS</span>
          <div class="player-field">
            <input
              type="text"
              class="player-input"
              [(ngModel)]="player2Name"
              (input)="searchUsers(player2Name, 2)"
              placeholder="Search by username or full name"
            />
            <ul *ngIf="filteredUsers2.length" class="suggestions-list">
              <li
                *ngFor="let s of filteredUsers2"
                (click)="selectSuggestion(s, 2)"
              >
                {{ s }}
              </li>
            </ul>
            <button
              *ngIf="showAdd2"
              type="button"
              class="add-btn"
              (click)="openAddDialog(2)"
            >
              Add New Player
            </button>
            <div class="booker-radio">
              <input
                type="radio"
                id="booker2"
                name="booker"
                [value]="2"
                [(ngModel)]="bookerIndex"
              />
              <label for="booker2">Booker</label>
            </div>
          </div>
        </div>
        <div *ngIf="matchType === 'double'" class="double-layout">
          <div class="team">
            <div class="team-label">Team 1</div>
            <div class="player-field">
              <input
                type="text"
                class="player-input"
                [(ngModel)]="player1Name"
                (input)="searchUsers(player1Name, 1)"
                placeholder="Search by username or full name"
              />
              <ul *ngIf="filteredUsers1.length" class="suggestions-list">
                <li
                  *ngFor="let s of filteredUsers1"
                  (click)="selectSuggestion(s, 1)"
                >
                  {{ s }}
                </li>
              </ul>
              <button
                *ngIf="showAdd1"
                type="button"
                class="add-btn"
                (click)="openAddDialog(1)"
              >
                Add New Player
              </button>
              <div class="booker-radio">
                <input
                  type="radio"
                  id="booker1"
                  name="booker"
                  [value]="1"
                  [(ngModel)]="bookerIndex"
                />
                <label for="booker1">Booker</label>
              </div>
            </div>
            <div class="player-field">
              <input
                type="text"
                class="player-input"
                [(ngModel)]="player2Name"
                (input)="searchUsers(player2Name, 2)"
                placeholder="Search by username or full name"
              />
              <ul *ngIf="filteredUsers2.length" class="suggestions-list">
                <li
                  *ngFor="let s of filteredUsers2"
                  (click)="selectSuggestion(s, 2)"
                >
                  {{ s }}
                </li>
              </ul>
              <button
                *ngIf="showAdd2"
                type="button"
                class="add-btn"
                (click)="openAddDialog(2)"
              >
                Add New Player
              </button>
              <div class="booker-radio">
                <input
                  type="radio"
                  id="booker2"
                  name="booker"
                  [value]="2"
                  [(ngModel)]="bookerIndex"
                />
                <label for="booker2">Booker</label>
              </div>
            </div>
          </div>
          <span class="vs-text">VS</span>
          <div class="team">
            <div class="team-label">Team 2</div>
            <div class="player-field">
              <input
                type="text"
                class="player-input"
                [(ngModel)]="player3Name"
                (input)="searchUsers(player3Name, 3)"
                placeholder="Search by username or full name"
              />
              <ul *ngIf="filteredUsers3.length" class="suggestions-list">
                <li
                  *ngFor="let s of filteredUsers3"
                  (click)="selectSuggestion(s, 3)"
                >
                  {{ s }}
                </li>
              </ul>
              <button
                *ngIf="showAdd3"
                type="button"
                class="add-btn"
                (click)="openAddDialog(3)"
              >
                Add New Player
              </button>
              <div class="booker-radio">
                <input
                  type="radio"
                  id="booker3"
                  name="booker"
                  [value]="3"
                  [(ngModel)]="bookerIndex"
                />
                <label for="booker3">Booker</label>
              </div>
            </div>
            <div class="player-field">
              <input
                type="text"
                class="player-input"
                [(ngModel)]="player4Name"
                (input)="searchUsers(player4Name, 4)"
                placeholder="Search by username or full name"
              />
              <ul *ngIf="filteredUsers4.length" class="suggestions-list">
                <li
                  *ngFor="let s of filteredUsers4"
                  (click)="selectSuggestion(s, 4)"
                >
                  {{ s }}
                </li>
              </ul>
              <button
                *ngIf="showAdd4"
                type="button"
                class="add-btn"
                (click)="openAddDialog(4)"
              >
                Add New Player
              </button>
              <div class="booker-radio">
                <input
                  type="radio"
                  id="booker4"
                  name="booker"
                  [value]="4"
                  [(ngModel)]="bookerIndex"
                />
                <label for="booker4">Booker</label>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="p-field mb-3">
        <label for="date">Date</label>
        <p-calendar
          id="date"
          [(ngModel)]="reservationDate"
          dateFormat="yy-mm-dd"
          [minDate]="minDate"
          (onSelect)="onDateChange()"
        ></p-calendar>
      </div>

        <div class="time-grid mb-3" *ngIf="times.length">
          <div
            class="time-box"
            *ngFor="let t of times"
            [class.available]="t.available"
            [class.unavailable]="!t.available"
            [class.selected]="selectedTimes.includes(t.hour)"
            (click)="selectTime(t.hour)"
          >
            {{ t.hour.toString().padStart(2, "0") }}:00
          </div>
        </div>
        <div class="mb-3" *ngIf="selectedTimes.length">
          <p>Total Price: {{ totalPrice }} RSD</p>
        </div>

        <div class="p-field mb-3" *ngIf="selectedTimes.length">
          <label for="court">Court</label>
          <p-dropdown
            id="court"
            [options]="availableCourts"
            optionLabel="name"
            [(ngModel)]="selectedCourt"
          ></p-dropdown>
        </div>

        <div class="p-field" *ngIf="selectedCourt">
          <button
            pButton
            type="button"
            label="Book"
            class="book-btn"
            (click)="bookCourt()"
          ></button>
        </div>
      </div>
    </div>
</p-card>

  <p-dialog
    header="{{ selectedClub?.name }}"
    [(visible)]="clubInfoVisible"
    [modal]="true"
    [style]="{ width: '50vw' }"
  >
    <ng-container *ngIf="selectedClub">
      <p><strong>Address:</strong> {{ selectedClub.location }}</p>
      <p><strong>Working Hours</strong></p>
      <ul>
        <li *ngFor="let h of getAllOpeningHours(selectedClub)">{{ h }}</li>
      </ul>
      <div *ngIf="selectedClub.clubOpeningExceptions?.length">
        <p><strong>Non-working Hours</strong></p>
        <ul>
          <li *ngFor="let e of selectedClub.clubOpeningExceptions">
            {{ formatException(e) }}
          </li>
        </ul>
      </div>
      <p><strong>Prices</strong></p>
      <ul>
        <li *ngFor="let p of getPricingHoursDisplay(selectedClub)">{{ p }}</li>
      </ul>
      <div *ngIf="selectedClub.clubPricingBundles?.length">
        <p><strong>Bundles</strong></p>
        <ul>
          <li *ngFor="let b of getBundleDisplay(selectedClub)">{{ b }}</li>
        </ul>
      </div>
      <div class="court-grid" *ngIf="courts.length">
        <div class="court-card" *ngFor="let c of courts">
          <img [src]="c.img_path" [alt]="c.name" />
          <span>{{ c.name }}</span>
        </div>
      </div>
    </ng-container>
  </p-dialog>

  <p-dialog
    header="Player Email"
    [(visible)]="emailDialogVisible"
    [modal]="true"
    [style]="{ width: '25rem' }"
  >
    <div class="p-fluid">
      <div class="p-field mb-3">
        <label for="basicEmail">Player Email</label>
        <input
          id="basicEmail"
          type="email"
          pInputText
          placeholder="name@example.com"
          [(ngModel)]="emailInput"
        />
      </div>
      <div class="dialog-actions">
        <button type="button" (click)="cancelEmail()">Cancel</button>
        <button
          type="button"
          (click)="saveEmail()"
          [disabled]="!emailInput || !isValidEmail(emailInput)"
        >
          Save
        </button>
      </div>
    </div>
  </p-dialog>

<div class="modal-backdrop" *ngIf="addDialogVisible">
  <div class="modal-content">
    <div *ngIf="creatingUser" class="spinner"></div>
    <div *ngIf="!creatingUser">
      <div class="mb-2">
        <label for="np-name">First Name*</label>
        <input id="np-name" [(ngModel)]="newPlayer.name" />
      </div>
      <div class="mb-2">
        <label for="np-last">Last Name*</label>
        <input id="np-last" [(ngModel)]="newPlayer.last_name" />
      </div>
      <div class="mb-2">
        <label for="np-email">Email</label>
        <input id="np-email" [(ngModel)]="newPlayer.email" />
      </div>
      <div class="mb-2">
        <label for="np-phone">Phone</label>
        <input id="np-phone" [(ngModel)]="newPlayer.phone_number" />
      </div>
      <div class="dialog-actions">
        <button type="button" (click)="closeAddDialog()">Cancel</button>
        <button
          type="button"
          (click)="createNewPlayer()"
          [disabled]="!newPlayer.name || !newPlayer.last_name || creatingUser"
        >
          Create
        </button>
      </div>
    </div>
  </div>
</div>

  <p-toast></p-toast>
</ng-container>
<ng-template #loading>
  <div class="text-center my-5">
    <span class="spinner-border" role="status"></span>
  </div>
</ng-template>
